import { useEffect, useState } from "react";
import styled from "styled-components";
import { NOTIFY, PLATFORM } from "../based/Constants";
import TFUSelect from "../based/inputs/TFUSelect";
import CommonModal from "../based/Modal";
import OrderServices from "../based/services/OrderServices";
import ReadyListServices from "../based/services/ReadyListServices";
import Tiktok from "./assets/Tiktok.svg"; // Adjust the import path as necessary
import SelectDesignModal from "./SelectDesignModal";
import { Notify } from "../based/Notify";

const initOrderCustomizeSyncModel = {
    platform: PLATFORM.Tiktok,
    shopId: "",
    shopName: "",
    productName: "",
    productAvatar: "",
    productAttribute: "",
    listProductAttribute: [],
};

const initPushingProductVariantExtendDTO = {
    id: 0,
    platform: PLATFORM.Tiktok,
    shopId: "",
    platformProductId: "",
    platformProductVariantId: "",
    platformSKU: "",
    designId: 0,
    productVariantId: 0,
    orderProductId: 0,
};

const sizeSort = ["S", "M", "L", "XL", "2XL", "3XL", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"];

function SyncVariantModal({ show, onClose, onSave, orderProductId }) {
    const [busy, setBusy] = useState(false);
    const [model, setModel] = useState({ ...initOrderCustomizeSyncModel });
    const [showSelectModal, setShowSelectModal] = useState(false);
    const [selectModel, setSelectModel] = useState({});

    useEffect(() => {
        if (orderProductId) getDetail(orderProductId);
    }, [orderProductId]);

    //save thông tin vào bảng map tay
    const saveSyncVariant = async () => {
        setBusy(true);

        var dto = { ...initPushingProductVariantExtendDTO };
        dto.platform = model.platform;
        dto.shopId = model.shopId;
        dto.platformProductVariantId = model.productSku;
        dto.designId = selectModel.designId;
        dto.orderProductId = orderProductId;
        dto.printType = selectModel.printType;

        if (selectModel && selectModel.designId > 0) {
            //lấy ra id của biến thể
            let size = selectModel.listSize.find((x) => x.value == selectModel.size);
            dto.productVariantId = size ? size.id : 0;
        }

        if (dto.productVariantId == 0) {
            setBusy(false);
            Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Vui lòng chọn biến thể sản phẩm.");
            return;
        }

        const [err, data] = await OrderServices.HandleSavePushingVariantExtends(dto);
        if (!err && data) {
            //refresh lại dữ liệu modal, tránh hiển thị dữ liệu cũ nếu mở lại modal cho cùng sản phẩm
            await getDetail(orderProductId);
            setSelectModel({});
            onSave();
        } else {
            // Xử lý lỗi nếu cần
            Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Lỗi khi đồng bộ biến thể sản phẩm.");
        }

        setBusy(false);
    };

    const getDetail = async (ordProductId) => {
        setBusy(true);
        const [err, data] = await OrderServices.GetOrderCustomizeSyncModel(ordProductId);
        if (!err && data) {
            setModel(data);
        } else {
            setModel({});
        }
        setBusy(false);
    };

    //chỉ lấy ra những dòng sản phẩm hiển thị của thiết kế đang chọn (designId)
    const getProductOptions = async (designId) => {
        const [err, data] = await ReadyListServices.GetReadyProductOptionsByDesignId(designId);
        if (!err) {
            return data.map((item) => ({
                label: item.name,
                value: item.id,
            }));
        } else return [];
    };

    const getColorOptions = async (appProductId) => {
        const [err, data] = await ReadyListServices.GetReadyProductColorOptions(appProductId);
        if (!err)
            return data.map((item) => ({
                label: item.displayName,
                value: item.name,
            }));
        else return [];
    };

    const getSize = async (model) => {
        const [err, data] = await ReadyListServices.GetReadyProductSizeOptions(model);
        if (!err) {
            let lstS = data.sort((a, b) => sizeSort.indexOf(a.size) - sizeSort.indexOf(b.size));
            return lstS;
        } else return [];
    };

    return (
        <>
            <CommonModal
                onClose={onClose}
                isBusy={busy}
                busyMsg={"Đang tải"}
                size="lg"
                show={show}
                title={`Đồng bộ biến thể`}
                onSave={() => {
                    // Logic to handle save action
                    saveSyncVariant();
                }}
            >
                <Wrapper>
                    <div className="subtraction">
                        <span>Sản phẩm chưa được đồng bộ với hệ thống. Vui lòng đồng bộ biến thể để có thể sản xuất và giao hàng.</span>
                    </div>
                    <div className="product-area">
                        <div className="logo-body">{model.platform === PLATFORM.Tiktok && <img src={Tiktok} alt="" />}</div>
                        <div className="product-body">
                            <div className="product-left">
                                <img src={model.productAvatar} alt="" />
                            </div>
                            <div className="product-right">
                                <div className="shop-name">{model.shopName}</div>
                                <div className="product-title">{model.productName}</div>
                                <div className="product-variant">
                                    <label>Biến thể trên đơn hàng:</label>
                                    <div className="list-badge">
                                        {model.listProductAttribute.map((item, index) => (
                                            <span className="badge-item" key={index}>
                                                {item}
                                            </span>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="select-variant-area">
                        <label>Chọn biến thể đồng bộ</label>
                        <div className="table-select">
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>Thiết kế trên Ranus</th>
                                        <th>Dòng sản phẩm</th>
                                        <th>Màu</th>
                                        <th>Size</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {selectModel && selectModel.designId > 0 ? (
                                        <tr>
                                            <td className="vertical-middle">
                                                <div className="product-detail">
                                                    <div className="img-variant">
                                                        <img src={selectModel.thumbnail} alt="" />
                                                    </div>
                                                    <div className="name-variant">
                                                        <div className="variant-top">
                                                            <span>{selectModel.name}</span>
                                                        </div>
                                                        <div className="variant-bottom">
                                                            <span
                                                                className="bottom-change cursor-pointer"
                                                                onClick={() => {
                                                                    setShowSelectModal(true);
                                                                }}
                                                            >
                                                                Thay đổi
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="select-design">
                                                    {selectModel.productOptions && (
                                                        <TFUSelect
                                                            placeholder="Chọn dòng sản phẩm"
                                                            options={selectModel.productOptions}
                                                            value={selectModel.appProductId}
                                                            onChanged={async (newVal) => {
                                                                //cập nhật lại appProductId
                                                                let itemProduct = { ...selectModel };
                                                                itemProduct.appProductId = +newVal;

                                                                //cập nhật lại màu sắc
                                                                let colorOptions = await getColorOptions(+newVal);
                                                                if (colorOptions && colorOptions.length > 0) {
                                                                    //kiểm tra sản phẩm hiện tại có đang mặc định
                                                                    //và trong list màu có đang mặc định hay không
                                                                    let colorCode = colorOptions[0].value;
                                                                    if (itemProduct.appProductId == itemProduct.sAppProductId) {
                                                                        let sColorCode = itemProduct.sColorCode;
                                                                        let findColor = colorOptions.find((x) => x.value == sColorCode);
                                                                        if (findColor) {
                                                                            colorCode = sColorCode;
                                                                            findColor.label = findColor.label + " (Mặc định)";
                                                                        }
                                                                    }

                                                                    itemProduct.colorCode = colorCode;
                                                                }
                                                                itemProduct.colorOptions = colorOptions;

                                                                //cập nhập lại list size
                                                                let lstSize = await getSize({
                                                                    appProductId: +newVal,
                                                                    colorCode: itemProduct.colorCode,
                                                                    designId: itemProduct.designId,
                                                                });
                                                                lstSize = lstSize.map((x) => ({ ...x, value: x.size, label: x.size }));
                                                                itemProduct.listSize = lstSize;

                                                                //set thông tin
                                                                setSelectModel(itemProduct);
                                                            }}
                                                        />
                                                    )}
                                                </div>
                                            </td>
                                            <td>
                                                <div className="color-name">
                                                    <TFUSelect
                                                        placeholder="Chọn màu"
                                                        options={selectModel.colorOptions}
                                                        value={selectModel.colorCode}
                                                        onChanged={(newVal) => {
                                                            //kiểm tra có khác với màu mặc định không
                                                            let diffDefault = selectModel.appProductId == selectModel.sAppProductId && newVal != selectModel.sColorCode;

                                                            const configSize = async () => {
                                                                //cập nhật lại màu sắc
                                                                let selected = { ...selectModel };
                                                                selected.colorCode = newVal;

                                                                //lấy ra list size theo màu
                                                                let lstSize = await getSize({
                                                                    appProductId: selected.appProductId,
                                                                    colorCode: newVal,
                                                                    designId: selected.designId,
                                                                });
                                                                lstSize = lstSize.map((x) => ({ ...x, value: x.size, label: x.size }));
                                                                selected.listSize = lstSize;
                                                                setSelectModel(selected);
                                                            };

                                                            //khác mặc định
                                                            if (diffDefault) {
                                                                ConfirmDialog("CẢNH BÁO", "Chọn khác màu gốc có thể sẽ ảnh hưởng đếnchất lượng hình in.", () => {
                                                                    return new Promise((resolve, reject) => {
                                                                        configSize();
                                                                        resolve({ title: "Thành công", msg: "Đổi màu thành công." });
                                                                    });
                                                                });
                                                            } else {
                                                                configSize();
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            </td>

                                            <td>
                                                <div className="select-size">
                                                    <TFUSelect
                                                        placeholder="Chọn size"
                                                        options={selectModel.listSize}
                                                        value={selectModel.size}
                                                        onChanged={(newVal) => {
                                                            let selected = { ...selectModel };
                                                            selected.size = newVal;
                                                            setSelectModel(selected);
                                                        }}
                                                    />
                                                </div>
                                            </td>
                                        </tr>
                                    ) : (
                                        <tr>
                                            <td
                                                colSpan={999}
                                                style={{
                                                    padding: "70px 20px !important",
                                                }}
                                            >
                                                <span
                                                    className="select-ranus-variant cursor-pointer"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        setShowSelectModal(true);
                                                    }}
                                                >
                                                    Chọn sản phẩm muốn đồng bộ <i className="fa fa-plus"></i>
                                                </span>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </Wrapper>
            </CommonModal>
            <SelectDesignModal
                show={showSelectModal}
                onClose={() => {
                    setShowSelectModal(false);
                }}
                onSave={async (item) => {
                    //sản phẩm - chỉ lấy những dòng sản phẩm hiển thị của thiết kế đang chọn
                    let productOptions = await getProductOptions(item.designId);
                    if (productOptions && productOptions.length > 0) {
                        //kiểm tra trong ds sản phẩm có sản phẩm mặc định hay không
                        let anySourceAppProductId = productOptions.find((x) => +x.value == item.sAppProductId);
                        if (anySourceAppProductId) {
                            //chọn mặc định sản phẩm
                            item.appProductId = item.sAppProductId;

                            //thêm vào label chữ mặc định
                            anySourceAppProductId.label = anySourceAppProductId.label + " (Mặc định)";
                        } else item.appProductId = +productOptions[0].value;
                    }
                    item.productOptions = productOptions;

                    //màu sắc
                    let colorOptions = await getColorOptions(item.appProductId);
                    if (colorOptions && colorOptions.length > 0) {
                        //kiểm tra trong ds màu có màu mặc định hay không
                        let anySourceColor = colorOptions.find((x) => x.value == item.sColorCode);
                        if (anySourceColor) {
                            //chọn mặc định màu
                            item.colorCode = item.sColorCode;

                            //thêm vào label chữ mặc định
                            anySourceColor.label = anySourceColor.label + " (Mặc định)";
                        } else item.colorCode = colorOptions[0].value;
                    }
                    item.colorOptions = colorOptions;

                    //lấy ra list size
                    if (item.appProductId > 0 && item.colorCode != "") {
                        let lstSize = await getSize({
                            appProductId: item.appProductId,
                            colorCode: item.colorCode,
                            designId: item.designId,
                        });
                        lstSize = lstSize.map((x) => ({ ...x, value: x.size, label: x.size }));
                        item.listSize = lstSize;
                    } else {
                        item.listSize = [];
                    }

                    //set select model
                    setSelectModel(item);

                    //close modal
                    setShowSelectModal(false);
                }}
            />
        </>
    );
}

export default SyncVariantModal;

const Wrapper = styled.div`
    .select-variant-area {
        margin: 24px 0;
    }

    .select-variant-area label {
        color: #a0a0a0;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .img-variant {
        width: 132px;
        height: 132px;
        flex-shrink: 0;
    }

    .img-variant img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    .name-variant {
        display: flex;
        margin-left: 10px;
        flex-direction: column;
        flex-wrap: wrap;
        height: 132px;
    }

    .product-detail {
        display: flex;
        align-items: flex-start;
    }

    .variant-top {
        color: #000;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .variant-bottom {
        margin-top: auto;
    }

    .variant-bottom span {
        color: #64c5b1;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }

    div.color-name {
        width: 150px;
    }

    .select-design {
        width: 230px;
    }

    .select-size {
        width: 120px;
    }

    span.select-ranus-variant {
        color: #64c5b1;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }

    .subtraction span {
        color: #333;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .subtraction {
        margin: 12px 0;
    }

    .product-area {
        background: #f1f1f1;
        padding: 12px 16px;
        display: flex;
        flex-wrap: wrap;
    }

    .logo-body {
        width: 100%;
        margin: 8px 0;
    }

    .product-body {
        display: flex;
        margin: 8px 0;
    }

    .product-left {
        width: 132px;
        flex-shrink: 0;
        height: 132px;
    }

    .product-left img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    .product-right {
        margin-left: 16px;
    }

    .shop-name {
        color: #000;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin: 6px 0;
    }

    .product-variant label {
        color: #a0a0a0;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .product-variant {
        margin: 6px 0;
    }

    .list-badge {
        display: flex;
    }

    .list-badge .badge-item {
        margin: 4px;
        border: 1px solid #e5e5e5;
        background: #fff;
        padding: 10px 16px;
        color: #000;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }
`;
